<template>
  <app-layout>
    <span slot="toolbar-title">{{ $t('nav.settings') }}</span>

    <q-page padding class="column">
      <q-field :label="$t('settings.language')" class="q-mb-md">
        <q-select
          :options="langs"
          v-model="lang"
        />
      </q-field>
      <q-btn
        color="primary"
        @click="logout"
        class="full-width"
        style="margin-top: auto;"
      >
        {{ $t('nav.log_out') }}
      </q-btn>
    </q-page>
  </app-layout>
</template>
<script>

export default {
  computed: {
    langs () {
      return [
        {
          label: this.$t('settings.finnish'),
          value: 'fi'
        },
        {
          label: this.$t('settings.english'),
          value: 'en'
        }
      ]
    },
    lang: {
      get () { return this.$i18n.locale },
      set (lang) {
        this.$i18n.locale = lang
        localStorage.setItem('lang', lang)
      }
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('setCurDate', new Date())
      this.$store.dispatch('logout')
    }
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('nav.settings')
    }
  }
}
</script>
